import { Component, HostListener, OnInit, Input } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { EstadoDescargaCertificadoStepperService } from "../../services/estado-descarga-certificado-stepper.service";
import { IStep } from "@shared/common/interfaces/step.interface";

@Component({
    selector: "app-descarga-certificado-stepper",
    templateUrl: "./descarga-certificado-stepper.component.html",
    styleUrls: ["./descarga-certificado-stepper.component.scss"],
    standalone: false
})
export class DescargaCertificadoStepperComponent implements OnInit {
  @Input() customSteps: IStep[] = [];
  step: number = 0;
  isResponsive: boolean = false;
  titleCurrentStepResponsive: string = "";
  currentStepResponsive: string = "";

  constructor(private readonly estadoTramiteStepper: EstadoDescargaCertificadoStepperService, private readonly router: Router) { }

  ngOnInit(): void {
    this.isResponsive = globalThis.innerWidth < 840;

    if (this.customSteps && this.customSteps.length > 0) {
      this.steps = structuredClone(this.customSteps);
    }
    
    this.getCurrentStep();

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Verificar si la URL actual es la que quieres redirigir
        if (event.url === '/pensions') {
          this.router.navigate(['/pensions/estado-tramite-pension']); // Redirecciona a la ruta base
        }
      }
    });
  }

  public steps: IStep[] = [
    { status: "pending", id: 1, title: 'Declaración y consideraciones', subTitle: 'Información de ahorros', titleMobile: 'Declaración' },
    { status: "pending", id: 2, title: 'Validación de identidad', subTitle: 'Ingreso de claves', titleMobile: 'Validación de identidad' },
    { status: "pending", id: 3, title: 'Descarga de certificado', subTitle: 'Obtener certificado', titleMobile: 'Descarga de certificado' },
    { status: "complete", id: 4, title: 'Confirmación de descarga', subTitle: 'Descarga exitosa', titleMobile: 'Confirmación de descarga' },
  ];

  getCurrentStep() {
    this.estadoTramiteStepper.stepCurrent.subscribe((response) => {
      this.step = response;
      const totalSteps = this.steps.length;
      for (const [index, step] of this.steps.entries()) {
        if (index + 1 < this.step) {
          step.status = "complete";
          this.titleCurrentStepResponsive = this.isResponsive ? step.titleMobile : step.subTitle;
          this.currentStepResponsive = `Paso ${index + 1} de ${totalSteps}`;
        } else if (index + 1 == this.step) {
          step.status = "current";
          this.titleCurrentStepResponsive = this.isResponsive ? step.titleMobile : step.subTitle;
          this.currentStepResponsive = `Paso ${index + 1} de ${totalSteps}`;
        } else {
          step.status = "pending";
        }
      }
    });
  }

  get progressPercent(): number {
    const total = this.steps.length;
    if (total <= 1) return 100;
    // si step es 1 (primer paso), queremos 0% completado; si step == total, 100%
    const index = Math.max(1, Math.min(this.step, total)); // clamp step
    return ((index - 1) / (total - 1)) * 100;
  }

  // calculateProgress() para mobile (ya la tienes)
  calculateProgress(): number {
    const completedSteps = this.steps.filter(step => step.status === 'current' || step.status === 'complete').length;
    return completedSteps / this.steps.length;
  }

  @HostListener("window:resize", ["$event"])
  onWindowResize() {
    this.isResponsive = window.innerWidth < 840;
  }
}
